import { forwardRef, useImperativeHandle, useState } from 'react';
import type { ViewIds } from '@ardoq/api-types';
import { PopoverAtPoint } from '@ardoq/popovers';
import { UrlFieldValueList } from '@ardoq/graph';
import type {
  SetUrlFieldValuesPopover,
  UrlFieldValuesPopoverState,
} from './getUrlFieldValuesPopoverState';

export type UrlFieldValuesPopoverHandle = {
  setUrlFieldValuesPopover: SetUrlFieldValuesPopover;
};

type UrlFieldValuesPopoverProps = {
  viewId: ViewIds;
};

const UrlFieldValuesPopover = forwardRef<
  UrlFieldValuesPopoverHandle,
  UrlFieldValuesPopoverProps
>(({ viewId }, ref) => {
  const [state, setState] = useState<UrlFieldValuesPopoverState | null>(null);
  useImperativeHandle(ref, () => ({ setUrlFieldValuesPopover: setState }), []);

  if (!state) {
    return null;
  }
  const close = () => setState(null);
  const { point, urlFieldValues } = state;
  return (
    <PopoverAtPoint
      point={point}
      isOpen
      onClose={close}
      placement={{ side: 'top', overflow: 'center' }}
      acceptsMouse
      onMouseLeave={close}
    >
      <UrlFieldValueList urlFieldValues={urlFieldValues} viewId={viewId} />
    </PopoverAtPoint>
  );
});
UrlFieldValuesPopover.displayName = 'UrlFieldValuesPopover';
export { UrlFieldValuesPopover };
